import React, { useEffect, useState } from "react";
import { fetchApiGet, fetchApiPost } from "../utils/FetchApi";
import { ApiName } from "../utils/ApiName";
import { useSearchParams } from "react-router-dom";
import tagManagerEvents from "../utils/GoogleTagManager";
import Landingmfs from "../pages/Landingmfs";
import { setCookie } from "../utils/CommonFunction";

type Props = {
  token: string | null;
};

const LandingmfsScreen = (props: Props) => {
  const [phoneNo, setPhoneNo] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [timer, setTimer] = useState(30);
  const [seconds, setSeconds] = useState(30);
  const [isHidden, setIsHidden] = useState(true);
  const [isChecked, setIsChecked] = useState(true);
  const [isFromParams, setIsFromParams] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");

  const [isResendClicked, setResendClicked] = useState(false);
  const [otp, setOtp] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
  });

  const [inputRef, setInputRef] = useState<React.RefObject<HTMLInputElement>[]>(
    [
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
    ],
  );
  const [searchParams] = useSearchParams();

  const usermsisdn = searchParams.get("usermsisdn");
  const walletmsisdn = searchParams.get("walletmsisdn");
  const utm_source: any = searchParams.get("utm_source");

  const parameter = searchParams.get("parameter") ?? "";
  const utm_campaign = searchParams.get("utm_campaign") ?? "";

  useEffect(() => {
    if (props.token) {
      if (walletmsisdn && usermsisdn) {
        onDecrypt(walletmsisdn);
      } else {
        getHe();
      }
    }
  }, [walletmsisdn, usermsisdn, props.token]);

  useEffect(() => {
    if (isResendClicked) {
      setSeconds(30);
      setResendClicked(false);
    }

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(interval);
        }
        return prevSeconds > 0 ? prevSeconds - 1 : 0;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isResendClicked]);

  useEffect(() => {
    let interval: string | number | NodeJS.Timeout | undefined;
    if (timer > 0) {
      interval = setTimeout(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => clearTimeout(interval);
  }, [timer]);

  const getHe = async () => {
    try {
      let response = await fetchApiGet(props.token, ApiName.checkHe);
      if (response.status === 0) {
        let phoneNumber = response.response.msisdn.slice(-10);
        setPhoneNo(phoneNumber);
      }
    } catch (error) {
      console.log("handleGetFlow Error: ", error);
    }
  };

  const handlePhoneNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isFromParams) return;
    let value = e.target.value;
    if (!value || (value.length <= 10 && value.match(/^3\d{0,9}$/))) {
      setShowError(false);
      setPhoneNo(e.target.value);
      setOtp({
        one: "",
        two: "",
        three: "",
        four: "",
      });
      if (value.length === 10) {
        if (paymentMethod === "easypaisa") {
          // tagManagerEvents("Ep_Number_Punched", utm_source);
          sendOTP(e.target.value, isFromParams);
        }
      }
    }
  };

  // decrypt

  const onDecrypt = async (phoneNo: string) => {
    let data = {
      msisdn: phoneNo,
    };
    try {
      let response = await fetchApiPost(
        props.token,
        ApiName.epDecrypt,
        data,
        true,
      );
      if (response.result) {
        // tagManagerEvents("Ep_Number_Punched", utm_source);
        setPhoneNo(response.result.slice(-10));
        if (paymentMethod === "easypaisa") {
          sendOTP(response.result, true);
        }
        setIsFromParams(true);
      }
    } catch (err) {
      getHe();
    }
  };

  const sendOTP = async (phoneNo: string, organic: boolean) => {
    let data = {};
    if (organic) {
      data = {
        enc_msisdn: walletmsisdn,
      };
    } else {
      data = {
        msisdn: phoneNo,
      };
    }
    const endpoint = organic
      ? ApiName.epGenerateOtpOrganic
      : ApiName.epGenerateOtp;
    try {
      let response = await fetchApiPost(props.token, endpoint, data);
      if (response.code === 0) {
        // tagManagerEvents("Ep_Otp_Send", utm_source);
      } else {
        setShowError(true);
        setErrorMsg("Unable to send OTP, Please try again.");
      }
    } catch (err) {
      setShowError(true);
      setErrorMsg("Something went wrong, Please try again.");
    }
  };

  // --------------- APIs ---------------

  const handleChangeOTP = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    let otpEntered = e.target.value;
    setShowError(false);

    if (!isNaN(otpEntered as any) && otpEntered !== " ") {
      setOtp({
        ...otp,
        [e.target.name]: otpEntered,
      });
      if (e.target.value.length === 1) {
        const nextInput = inputRef[index + 1];
        if (nextInput?.current) {
          nextInput.current.focus();
        }
      }
    } else {
      setShowError(true);
      setErrorMsg("Please enter a valid OTP");
    }
  };
  // backspace button
  const handleBackspace = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ): void => {
    if (e.keyCode === 8) {
      setShowError(false);
      const target = e.target as HTMLInputElement;
      if (target.value.length === 0 && index !== 0) {
        (inputRef[index - 1].current as HTMLInputElement).focus();
      }
    }
  };

  const onResendOtpPressed = async () => {
    setTimer(30);
    setResendClicked(true);
    setOtp({
      one: "",
      two: "",
      three: "",
      four: "",
    });
    sendOTP(phoneNo, isFromParams);
  };

  const onVerifyPressed = () => {
    if (isChecked) {
      let checkOTP = otp.one + otp.two + otp.three + otp.four;
      const endPoint = isFromParams
        ? ApiName.epVerifyLinkOtpOrganic
        : ApiName.epVerifyLinkOtp;

      let data = {};
      if (isFromParams) {
        data = {
          msisdn: usermsisdn,
          enc_msisdn: walletmsisdn,
          otp: checkOTP,
          source: utm_source,
          sub_source: parameter,
        };
      } else {
        data = {
          msisdn: phoneNo,
          otp: checkOTP,
          source: utm_source,
          sub_source: parameter,
        };
      }

      VerifyLinkOtp(endPoint, data);
    } else {
      setShowError(true);
      setErrorMsg("Please accept the terms and conditions to proceed.");
    }
  };

  const VerifyLinkOtp = async (endpoint: string, data: any) => {
    try {
      setShowLoader(true);
      let response = await fetchApiPost(props.token, endpoint, data);
      if (response.code === 0) {
        setIsHidden(false);
        setShowLoader(false);
        tagManagerEvents("Ep_Subscribe_Mfs", utm_source);
      } else {
        // tagManagerEvents("Ep_Subscription_Failed", utm_source);
        setShowLoader(false);
        setShowError(true);
        setErrorMsg(
          response.message || "Unable to subscribe, Please try again.",
        );
      }
    } catch (error) {
      // tagManagerEvents("Ep_Subscription_Failed", utm_source);
      setShowLoader(false);
      setShowError(true);
      setErrorMsg("Unable to subscribe,Please try again.");
    }
  };

  const handleOverLay = () => {
    setIsHidden(true);
  };
  const onPressCheckBox = () => {
    setIsChecked(!isChecked);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    console.log("e.target.value", value);
    setPaymentMethod(value);
    setErrorMsg("");
    setShowError(false);
    if (value === "easypaisa" && phoneNo.length === 10) {
      setTimer(30);
      setResendClicked(true);
      sendOTP(phoneNo, isFromParams);
      setOtp({
        one: "",
        two: "",
        three: "",
        four: "",
      });
    } else if (value === "jazzcash" && phoneNo.length === 10) {
      handleNavigation();
    }
  };

  //jazz Cash

  const handleNavigation = () => {
    if (phoneNo.length === 10 && isChecked) {
      // tagManagerEvents("Proceed_Button_Click", utm_source);
      setUtmInCookies(utm_source, phoneNo, true);

      setTimeout(() => {
        window.location.replace(
          `https://subscribe.tamashaweb.com/api/link-wallet-initialize?msisdn=${phoneNo}&package_id=3&utm_source=${utm_source}&sub_source=${parameter}`,
        );
      }, 500);
    } else if (phoneNo.length != 10) {
      setErrorMsg("Please enter a valid 10-digit number");
    } else {
      setErrorMsg("Please agree to the Terms of Use and Privacy Policy");
    }
  };

  const setUtmInCookies = (utmSource: string, msisdn: string, mfs: boolean) => {
    console.log("utmSource ::", utmSource);
    setCookie(utmSource, msisdn, mfs);
  };

  return (
    <Landingmfs
      showLoader={showLoader}
      errorMsg={errorMsg}
      showError={showError}
      phoneNo={phoneNo}
      otp={otp}
      isChecked={isChecked}
      seconds={seconds}
      isHidden={isHidden}
      inputRef={inputRef}
      paymentMethod={paymentMethod}
      parameter={parameter}
      utm_campaign={utm_campaign}
      handleChange={handleChange}
      onPressCheckBox={onPressCheckBox}
      onVerifyPressed={onVerifyPressed}
      handleChangeOTP={handleChangeOTP}
      handleBackspace={handleBackspace}
      onResendOtpPressed={onResendOtpPressed}
      handlePhoneNoChange={handlePhoneNoChange}
      handleOverLay={handleOverLay}
      handleNavigation={handleNavigation}
    />
  );
};

export default LandingmfsScreen;
